module.exports = __webpack_public_path__ + "img/tranding-up.e1d2b445.svg";